export const EXHIBITOR_INQUIRIES_PATH = "/my-expos/inquiries";

export const EXHIBITOR_INQUIRY_COUNT_REFRESH_EVENT = "gt:exhibitor-inquiry-count-refresh";

export function exhibitorExpoInquiriesPath(expoSlug: string) {
  return `${EXHIBITOR_INQUIRIES_PATH}/${encodeURIComponent(expoSlug)}`;
}

export function isExhibitorInquiriesPath(pathname: string) {
  return pathname === EXHIBITOR_INQUIRIES_PATH || pathname.startsWith(`${EXHIBITOR_INQUIRIES_PATH}/`);
}

export function exhibitorInquiryExpoSlugFromPath(pathname: string) {
  if (!pathname.startsWith(`${EXHIBITOR_INQUIRIES_PATH}/`)) return null;
  const slug = decodeURIComponent(pathname.slice(EXHIBITOR_INQUIRIES_PATH.length + 1).split("/")[0] ?? "");
  return slug.trim() || null;
}

function lastSeenByExpoKey(userId: string) {
  return `gt.exhibitorInquiries.lastSeenByExpo.${userId}`;
}

export function readExhibitorInquiryLastSeenBySlug(userId: string): Record<string, string> {
  try {
    const raw = localStorage.getItem(lastSeenByExpoKey(userId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, string>;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function readExhibitorInquiryExpoLastSeenAt(userId: string, expoSlug: string): string | null {
  const value = readExhibitorInquiryLastSeenBySlug(userId)[expoSlug];
  return typeof value === "string" && value.trim() ? value : null;
}

export function markExhibitorInquiryExpoSeen(userId: string, expoSlug: string) {
  try {
    const next = { ...readExhibitorInquiryLastSeenBySlug(userId), [expoSlug]: new Date().toISOString() };
    localStorage.setItem(lastSeenByExpoKey(userId), JSON.stringify(next));
  } catch {
    /* ignore quota / private mode */
  }
}

export function notifyExhibitorInquiryCountChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(EXHIBITOR_INQUIRY_COUNT_REFRESH_EVENT));
}
